import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class InstituteEffects {
  private readonly actions$: Actions = inject(Actions);
}
